import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { Box, Skeleton, Stack, useTheme } from "@mui/material";

const CustomerProfileSkeleton = () => {
  const theme = useTheme();
  const { isMobile } = useScreenSize();

  if (isMobile) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          width: "100%",
          gap: theme.nawy.spacing.xs,
        }}
      >
        {/* Left Column - Labels and Name/Company */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: theme.nawy.spacing.xs,
            flex: 1,
          }}
        >
          {/* Row 1: Status Label */}
          <Box
            sx={{
              display: "flex",
              gap: theme.nawy.spacing.xs,
              flexWrap: "wrap",
            }}
          >
            <Skeleton variant="rectangular" width={60} height={24} />
          </Box>

          {/* Row 2: Name and Company */}
          <Stack
            direction="column"
            sx={{ display: "flex", alignItems: "start" }}
          >
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <Skeleton variant="text" width={120} height={28} />
            </Box>
            <Skeleton variant="text" width={80} height={20} />
          </Stack>
        </Box>

        {/* Right Column - Action Buttons */}
        <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
          <Stack direction="row" spacing={1}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="circular" width={32} height={32} />
          </Stack>
        </Box>
      </Box>
    );
  }

  // Desktop (non-compact) layout
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: theme.nawy.spacing.md,
        width: "100%",
      }}
    >
      {/* Label skeleton */}
      <Box
        sx={{ display: "flex", gap: theme.nawy.spacing.xs, flexWrap: "wrap" }}
      >
        <Skeleton variant="rectangular" width={60} height={24} />
      </Box>
      {/* Name and company skeletons */}
      <Stack
        direction="column"
        width="100%"
        sx={{ display: "flex", alignItems: "start" }}
      >
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Skeleton variant="text" width={120} height={28} />
        </Box>
        <Skeleton variant="text" width={80} height={20} />
      </Stack>
      {/* Action buttons skeletons */}
      <Stack direction="row" spacing={1} width="100%">
        <Skeleton variant="rectangular" width="100%" height={32} />
        <Skeleton variant="rectangular" width="100%" height={32} />
      </Stack>
    </Box>
  );
};

export default CustomerProfileSkeleton;
